import React from 'react';
import { Image, Text, VStack, Wrap, WrapItem, } from '@chakra-ui/react';
import { useTokens } from '../../../../context/TokenProvider';
import { localise } from '../../../../services/lang/lang';
import PhotoBox from '../../../modules/Photos/PhotoBox';
import { getLocalPreviewUrls } from '../../../../services/photos/remoteSubmissionMediaCache';
const EvidenceSentMediaField = ({ remoteSubmission, ...rest }) => {
    const tokens = useTokens();
    const localPreviews = getLocalPreviewUrls(remoteSubmission.id);
    return (React.createElement(VStack, { "data-testid": "evidence_sent_media_field", align: "flex-start", gap: tokens.Spacing02, ...rest },
        React.createElement(Text, { variant: "dk-800-md-4" }, localise('MEDIA')),
        React.createElement(Wrap, { spacing: tokens.Spacing04 }, localPreviews.map((url, id) => (React.createElement(WrapItem, { "data-testid": "image_wrap_item", key: id },
            React.createElement(PhotoBox, null,
                React.createElement(Image, { src: url, borderRadius: tokens.Spacing02, objectFit: "cover", boxSize: "100%" }))))))));
};
export default EvidenceSentMediaField;
